import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field, BigButton } from "@/components/Field";
import { SelectField, TextArea } from "@/components/Bits";
import { api, errMsg } from "@/lib/api";

const TIPOS = [
  { value: "entrada", label: "Entrada (compra)" }, { value: "retirada", label: "Retirada pelo técnico" },
  { value: "devolucao", label: "Devolução do técnico" }, { value: "saida", label: "Saída manual (perda, venda)" },
];

export const MovDialog = ({ prod, onOpenChange, equipe, onSaved }) => {
  const [f, setF] = useState({ tipo: "entrada", quantidade: "", tecnico_id: "", observacao: "" });
  useEffect(() => { if (prod) setF({ tipo: "entrada", quantidade: "", tecnico_id: "", observacao: "" }); }, [prod]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const needTec = ["retirada", "devolucao"].includes(f.tipo);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/estoque/movimentos", { produto_id: prod.produto_id, tipo: f.tipo, quantidade: Number(f.quantidade), tecnico_id: needTec ? f.tecnico_id : null, observacao: f.observacao || null });
      toast.success("Movimentação registrada"); onOpenChange(false); onSaved();
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <Dialog open={!!prod} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-3xl" data-testid="mov-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">{prod?.nome}</DialogTitle></DialogHeader>
        <p className="-mt-2 text-sm text-[#5C6B66]">Depósito: <b>{prod?.deposito}</b> · Com técnicos: <b>{prod?.com_tecnicos}</b></p>
        <form onSubmit={submit} className="space-y-4">
          <SelectField label="Movimentação *" id="mv-tipo" value={f.tipo} onChange={set("tipo")} options={TIPOS} data-testid="mov-tipo" />
          {needTec && <SelectField label="Técnico *" id="mv-tec" required placeholder="Selecione" value={f.tecnico_id} onChange={set("tecnico_id")}
            options={(equipe || []).map((u) => ({ value: u.user_id, label: u.name }))} data-testid="mov-tecnico" />}
          <Field label="Quantidade *" id="mv-qtd" type="number" min="0.01" step="any" required value={f.quantidade} onChange={set("quantidade")} data-testid="mov-quantidade" />
          <TextArea label="Observação" id="mv-obs" value={f.observacao} onChange={set("observacao")} data-testid="mov-observacao" />
          <BigButton type="submit" data-testid="mov-submit">Registrar</BigButton>
        </form>
      </DialogContent>
    </Dialog>
  );
};
